import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, total: 0, data: [] , error: "", message: "" }


export const highConvertingSurveyAction = createAsyncThunk(
    'high-converting-survey',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.post(`/admins/api/high-converting-sruvey?page=${data.page}&limit=${data.limit}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

 
export const highCovertingSurveySlice = createSlice({
    name: 'high-converting-survey',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(highConvertingSurveyAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(highConvertingSurveyAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.total = action?.payload?.total
            })
            builder.addCase(highConvertingSurveyAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const highCovertingSurveyReducer = highCovertingSurveySlice.reducer